import { Form, Formik } from "formik";
// import { withFormikDevtools } from "formik-devtools-extension";
import { object, ref, string } from "yup";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { InputField } from "components";
import {
  changeAddress,
  changePassword,
} from "store/authentication/authentication.slice";

import "components/form/FormikForm.scss";

type ChangeAddressFormProp = {
  id: 0;
  state_name: string;
  region_name: string;
  city_name: string;
  location: string;
  zip: string;
  street_name: string;
  street_number: string;
  google_maps_link: string;
  longitude: string;
  latitude: string;
};
const ChangeAddressForm = () => {
  const { t } = useTranslation("registration", { useSuspense: false });
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const initialValue = location.state || {};

  const Validation = object().shape({
    state_name: string().required("Unesite naziv države"),
    city_name: string().required("Unesite naziv grada"),
    zip: string().required("Unesite poštanski broj"),
    street_name: string().required("Unesite naziv ulice"),
    street_number: string().required("Unesite broj objekta"),
  });

  const handleSubmit = (values: any, { setSubmitting }: any) => {
    dispatch(changeAddress(values)).then(() => {
      setSubmitting(false);
      navigate("/profile");
    });
  };

  return (
    <div className="Form-Box">
      <div className="Form">
        <h2>Promjeni adresu</h2>
        <Formik
          initialValues={initialValue}
          validationSchema={Validation}
          onSubmit={handleSubmit}
        >
          {(
            //   formikProps.values,
            //   formikProps.errors,
            //   formikProps.touched,
            //   formikProps.handleChange,
            //   formikProps.handleBlur,
            //   formikProps.handleSubmit,
            // formikProps.isSubmitting,
            formikProps
          ) => (
            // withFormikDevtools(
            //   formikProps,
            <Form className="Formik-Form">
              <InputField
                name="state_name"
                label={"Naziv drzave"}
                required={true}
              />
              <InputField
                name="region_name"
                label={"Naziv regiona"}
                required={false}
              />
              <InputField
                name="city_name"
                label="Naziv grada"
                required={true}
              />
              <InputField
                name="location"
                label="Naziv mesta"
                required={false}
              />
              <InputField name="zip" label="Poštanski broj" required={true} />
              <InputField
                name="street_name"
                label="Naziv ulice"
                required={true}
              />
              <InputField
                name="street_number"
                label="Broj objekta"
                required={true}
              />

              <button
                type="submit"
                disabled={formikProps.isSubmitting}
                className="Form-Button"
              >
                {t("potvrdi")}
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};
export default ChangeAddressForm;
